import { Injectable, Pipe, PipeTransform } from '@angular/core';

export type SortOrder = 'asc' | 'desc';

@Injectable()
@Pipe({
  name: 'sort',
  standalone: true,
})
export class SortPipe implements PipeTransform {
  private readonly compareNumbers = (a: number, b: number): number => a - b;

  private readonly compareStrings = (a: string, b: string): number =>
    a.localeCompare(b);

  transform(
    value: any[],
    sortOrder: SortOrder | string = 'asc',
    sortKey?: string
  ): any {
    sortOrder = sortOrder && (sortOrder.toLowerCase() as any);

    if (!value || (sortOrder !== 'asc' && sortOrder !== 'desc')) return value;

    let numberArray = [];
    let stringArray = [];

    if (!sortKey) {
      numberArray = value
        .filter(item => typeof item === 'number')
        .sort(this.compareNumbers);
      stringArray = value
        .filter(item => typeof item === 'string')
        .sort(this.compareStrings);
    } else {
      numberArray = value
        .filter(item => typeof item[sortKey] === 'number')
        .sort((a, b) => this.compareNumbers(a[sortKey], b[sortKey]));
      stringArray = value
        .filter(item => typeof item[sortKey] === 'string')
        .sort((a, b) => this.compareStrings(a[sortKey], b[sortKey]));
    }
    const sorted = numberArray.concat(stringArray);
    return sortOrder === 'asc' ? sorted : sorted.reverse();
  }
}
